import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { onImageHandlerOneByOne } from "../../../../common/Image upload on bucket/UploadImageOnBucket";
import Skeleton from "react-loading-skeleton";
import { useDispatch } from "react-redux";
import { UpdateKnowledgeInsightSlice } from "../../../../redux/features/Knowledge insight by Admin/PendingKnowledgeInsigth";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { IoMdClose } from "react-icons/io";

function EditKnowledgeInsight({ show, setShow, StateForUpdate,setUpdateView}) {
  //   const [show, setShow] = useState(false);

  
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);


  const [iState, setUpdate] = useState({});
   const [loading, setLoading] = useState({
      imageUpload: false,
    });

  useEffect(() => {
    setUpdate(StateForUpdate);
  }, [StateForUpdate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdate((prev) => ({ ...prev, [name]: value }));
  };

  const hanldeImage = async ({ e} ) => {
    const { name, files } = e.target;

    let allFiles = Object.values(files);
    try {
      setLoading((prev) => ({ ...prev, imageUpload: true }));
      let res = allFiles?.map((res) => onImageHandlerOneByOne(res));
      setLoading((prev) => ({ ...prev, imageUploadPenidng: res }));
      let uploadedImages = await axios.all(res);
      console.log(uploadedImages);
      setLoading((prev) => ({ ...prev, imageUpload: false }));
      setUpdate((prev) => ({ ...prev, images:[...prev["images"],...uploadedImages] }));
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

    } catch (err) {
      console.log(err);
    }
  };


  const handleSubmit = () => {
    dispatch(UpdateKnowledgeInsightSlice({ id: iState?._id, data: iState })).then((res)=>{
      if(res?.payload?.customStatus === 200){
        console.log(res?.payload?.data)
        setUpdateView(res?.payload?.data)
        toast.success('Article Edited Successfully!');
      }
      handleClose()
    })
    console.log(iState);
  };

  
  const hanldeRemoveImage=(index)=>{
    const temp = iState?.images?.filter((item,i)=>index !== i);
    setUpdate((prev) => ({ ...prev, images:[...temp] }));
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Edit Quix Sense Article</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="CommonForm">
          <h4>Edit QuixSense</h4>
          <div
            className="row"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "20px",
                }}
              >
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>News title</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={handleChange}
                          value={iState?.title}
                          name="title"
                          placeholder="Enter News title..."
                        />
                      </div>
                    </div>

                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>News Description</label>
                        <textarea
                          type="text"
                          className="form-control"
                          onChange={handleChange}
                          value={iState?.description}
                          name="description"
                          placeholder="Enter News ..."
                        />
                      </div>
                    </div>

                    <div className="col-sm-4">
                  <div className="form-group">
                    <label>Upload Images </label>
                    <div className="UploadBox">
                      <div className="Upload">
                        <>
                          <i className="fa fa-upload" /> <span>Upload </span>
                          <input
                            type="file"
                            name="images"
                            multiple
                            ref={fileInputRef}
                            onChange={(e) =>
                              hanldeImage({e})
                            }
                          />
                        </>
                      </div>
                     </div>
                  </div>
                </div>

                  </div>
                </div>
            </div>
          </div>
        </div>
        <div style={{display:'flex', width:'100%', flexWrap:'wrap', gap:'10px'}}>
              { Array.isArray(iState?.images) && iState?.images?.map((item,index) => {
                return(
                  <div style={{position:'relative',height:'200px',width:'200px',border:'4px solid gray',marginRight:'10px'}}>
                 <img src={item} alt="" className="w-100 h-100" srcset="" />
                 <IoMdClose onClick={()=>hanldeRemoveImage(index)} style={{cursor:'pointer',position:'absolute',top:'-12px',right:'-15px',border:'3px solid gray',color:'white',backgroundColor:'gray',borderRadius:'15px',width:'20px',height:'20px'}}/>
                  </div>
                )
              })}
               {loading?.imageUpload &&
                          loading?.imageUploadPenidng?.map((item) => {
                            return (
                              <>
                               <div style={{
                                   height: "200px",
                                   width: "200px",
                                   marginRight: "10px",
                               }}>
                                <Skeleton width={"100%"} height={"100%"} />{" "}
                                </div>
                              </>
                            );
                          })}
            </div>
      </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditKnowledgeInsight;
